import React from 'react';
import { LogoLockup } from '../brand/LogoLockup';
import { ClientLogoStrip } from './ClientLogoStrip';
import { hero } from '../../data/site';
interface HeroProps {
  stripAligned?: boolean;
}
export const HERO_ID = 'hero';
export function Hero({
  stripAligned = true
}: HeroProps) {
  return <section id={HERO_ID} aria-labelledby="hero-title" data-id="element-93" data-mp="hvh2onuimc17">
      <div className="mx-auto max-w-page px-6 pb-10 pt-6 md:px-12 md:pb-12 md:pt-12 lg:pb-14 lg:pt-12 xl:px-20" data-id="element-94" data-mp="hsutkjrz7ogv">
        <div className="grid gap-10 md:grid-cols-12 md:gap-8" data-id="element-95" data-mp="qvm7cq8bqwbo">
          <div className="hidden md:col-span-4 md:block md:pt-2" data-id="element-96" data-mp="qu2rh0qkynaf">
            <LogoLockup className="w-full max-w-[260px]" data-id="element-97" data-mp="vm2mcersmq05" />
          </div>
          <div className="md:col-span-8" data-id="element-98" data-mp="10lfffh99ctb6">
            {/* Phones: a compact, trimmed lockup so the headline and paragraph still sit above the fold. */}
            <LogoLockup trimmed className="mb-7 w-[124px] md:hidden" data-id="element-99" data-mp="15m37m6983g6z" />
            <h1 id="hero-title" className="max-w-[18ch] font-display text-[32px] font-light leading-[1.1] tracking-[-0.015em] text-graphite sm:text-[44px] md:text-[48px] lg:text-[60px] lg:leading-[1.05] xl:text-[68px]" data-id="element-100" data-mp="1aitouwwrkhtz">
              {hero.headline}
            </h1>
            <p className="mt-5 max-w-[52ch] text-[17px] leading-[1.6] text-ridge md:mt-8 md:text-[19px]" data-id="element-101" data-mp="3vw2aio51cin7">{hero.paragraph}</p>
          </div>
        </div>
      </div>
      <ClientLogoStrip aligned={stripAligned} data-id="element-102" data-mp="seamfku0siua" />
    </section>;
}